<template>
  <div class="reward-container">
    <el-tooltip
      placement="left"
      :visible="showQRCode"
      :show-after="0"
      :hide-after="0"
      manual
      popper-class="beautified-qrcode-tooltip"
    >
      <template #content>
        <div class="qrcode-content">
          <!-- 装饰性头部 -->
          <div class="qrcode-header">
            <div class="sparkle">✨</div>
            <h3 class="qrcode-title">感谢您的支持</h3>
            <div class="sparkle">✨</div>
          </div>

          <!-- 二维码区域 -->
          <div class="qrcode-wrapper">
            <div class="qrcode-frame">
              <img
                src="@/assets/wechat-qrcode.jpg"
                alt="微信打赏二维码"
                class="qrcode-image"
                @error="handleImageError"
                @load="handleImageLoad"
              />
              <!-- 加载动画 -->
              <div v-if="imageLoading" class="qrcode-loading">
                <div class="loading-spinner"></div>
                <span>加载中...</span>
              </div>
            </div>
          </div>

          <!-- 装饰性底部 -->
          <div class="qrcode-footer">
            <div class="decoration-line"></div>
            <p class="qrcode-desc">扫描二维码，支持作者继续创作</p>
            <div class="thank-text">衷心感谢！❤️</div>
          </div>

          <!-- 浮动装饰元素 -->
          <div class="floating-element coin-1">💰</div>
          <div class="floating-element coin-2">💎</div>
          <div class="floating-element coin-3">⭐</div>
        </div>
      </template>

      <div
        class="reward-button"
        @mouseenter="onHoverIn"
        @mouseleave="onHoverOut"
        @click="onTouchToggle"
      >
        <div class="reward-icon-wrapper">
          <svg class="reward-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" fill="#FFFFFF"></path>
            <path d="M672 558.4c0 88.8-71.2 160-160 160s-160-71.2-160-160 71.2-160 160-160 160 71.2 160 160z m-160-96c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z" fill="#FFFFFF"></path>
            <path d="M512 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" fill="#FFFFFF"></path>
          </svg>
          <div class="pulse-effect"></div>
        </div>
        <span class="reward-text">打赏</span>
        <div class="reward-glow"></div>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'RewardButton',
  data() {
    return {
      showQRCode: false,
      imageLoading: true,
      // 触摸设备没有 hover，改为点击切换
      isTouch:
        typeof window !== 'undefined' &&
        window.matchMedia &&
        !window.matchMedia('(hover: hover)').matches
    }
  },
  methods: {
    // 桌面端悬停展开
    onHoverIn() {
      if (this.isTouch) return
      this.showQRCode = true
    },

    onHoverOut() {
      if (this.isTouch) return
      this.showQRCode = false
    },

    // 移动端点击切换（无 hover 能力）
    onTouchToggle() {
      if (!this.isTouch) return
      this.showQRCode = !this.showQRCode
    },

    // 处理图片加载错误
    handleImageError(event) {
      console.warn('微信二维码图片加载失败，请检查图片路径')
      this.imageLoading = false
      event.target.style.display = 'none'

      // 显示备用内容
      const wrapper = event.target.parentElement
      const loadingElement = wrapper.querySelector('.qrcode-loading')
      if (loadingElement) {
        loadingElement.innerHTML = `
          <div class="error-icon">❌</div>
          <span>二维码加载失败</span>
          <p class="error-hint">请稍后重试</p>
        `
        loadingElement.className = 'qrcode-error'
      }
    },

    // 图片加载完成
    handleImageLoad() {
      this.imageLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
// ===== 打赏按钮容器 =====
.reward-container {
  position: fixed;
  right: 30px;
  bottom: 120px;
  z-index: 9999;

  .reward-button {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 70px;
    background: linear-gradient(135deg, #ff6b35, #ff8e35, #ffa235);
    border-radius: 50%;
    box-shadow:
      0 8px 25px rgba(255, 107, 53, 0.4),
      0 2px 8px rgba(255, 107, 53, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    overflow: hidden;

    &:hover {
      transform: scale(1.15) rotate(5deg);
      box-shadow:
        0 12px 35px rgba(255, 107, 53, 0.6),
        0 4px 15px rgba(255, 107, 53, 0.4);
    }

    &:active {
      transform: scale(1.1) rotate(0deg);
    }

    .reward-icon-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      margin-bottom: 4px;

      .reward-icon {
        width: 24px;
        height: 24px;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
        z-index: 2;
        position: relative;
      }

      .pulse-effect {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        animation: rewardPulse 2s infinite;
        z-index: 1;
      }
    }

    .reward-text {
      color: white;
      font-size: 13px;
      font-weight: 700;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      letter-spacing: 0.5px;
      z-index: 2;
      position: relative;
    }

    .reward-glow {
      position: absolute;
      top: -10px;
      left: -10px;
      right: -10px;
      bottom: -10px;
      background: radial-gradient(circle, rgba(255, 107, 53, 0.4) 0%, transparent 70%);
      border-radius: 50%;
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 1;
    }

    &:hover .reward-glow {
      opacity: 1;
    }
  }
}

@keyframes rewardPulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

// 响应式调整
@media (max-width: 768px) {
  .reward-container {
    right: 16px;
    // 抬高，避开移动端底部导航与悬浮新增按钮
    bottom: 168px;

    .reward-button {
      width: 60px;
      height: 60px;

      .reward-icon-wrapper {
        width: 28px;
        height: 28px;

        .reward-icon {
          width: 20px;
          height: 20px;
        }
      }

      .reward-text {
        font-size: 11px;
      }
    }
  }
}
</style>

<!-- 二维码提示框样式：需要全局，因为 tooltip 挂载在 body 上 -->
<style lang="less">
.beautified-qrcode-tooltip {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;

  .el-tooltip__popper::before {
    display: none;
  }

  .qrcode-content {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 20px;
    padding: 24px;
    box-shadow:
      0 20px 40px rgba(0, 0, 0, 0.15),
      0 8px 25px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    position: relative;
    overflow: hidden;
    min-width: 280px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="rgba(255,255,255,0.05)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
      pointer-events: none;
    }
  }

  .qrcode-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 20px;

    .sparkle {
      font-size: 18px;
      animation: sparkle 2s ease-in-out infinite;

      &:nth-child(1) {
        animation-delay: 0s;
      }
      &:nth-child(3) {
        animation-delay: 1s;
      }
    }

    .qrcode-title {
      color: white;
      font-size: 18px;
      font-weight: 700;
      margin: 0;
      text-align: center;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }
  }

  .qrcode-wrapper {
    display: flex;
    justify-content: center;
    margin: 20px 0;

    .qrcode-frame {
      position: relative;
      background: white;
      border-radius: 12px;
      padding: 16px;
      box-shadow:
        0 8px 25px rgba(0, 0, 0, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);

      .qrcode-image {
        width: 200px;
        height: 200px;
        border-radius: 8px;
        display: block;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.02);
        }
      }

      .qrcode-loading,
      .qrcode-error {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 200px;
        color: #666;
        gap: 12px;

        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #667eea;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .error-icon {
          font-size: 32px;
        }

        .error-hint {
          font-size: 12px;
          color: #999;
          margin: 0;
        }
      }
    }
  }

  .qrcode-footer {
    text-align: center;
    margin-top: 20px;

    .decoration-line {
      height: 2px;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
      margin: 16px 0;
    }

    .qrcode-desc {
      color: rgba(255, 255, 255, 0.9);
      font-size: 14px;
      margin: 0 0 12px 0;
      font-weight: 500;
    }

    .thank-text {
      color: #ffd700;
      font-size: 13px;
      font-weight: 600;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      animation: thankPulse 2s ease-in-out infinite;
    }
  }

  .floating-element {
    position: absolute;
    font-size: 20px;
    animation: float 3s ease-in-out infinite;
    pointer-events: none;

    &.coin-1 {
      top: 20px;
      left: 20px;
      animation-delay: 0s;
    }

    &.coin-2 {
      top: 30px;
      right: 25px;
      animation-delay: 1s;
    }

    &.coin-3 {
      bottom: 40px;
      left: 30px;
      animation-delay: 2s;
    }
  }
}

@keyframes sparkle {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(10deg);
  }
}

@keyframes thankPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

// 移动端适配
@media (max-width: 768px) {
  .beautified-qrcode-tooltip {
    .qrcode-content {
      padding: 20px;
      min-width: 260px;
    }

    .qrcode-wrapper .qrcode-frame {
      padding: 12px;

      .qrcode-image {
        width: 180px;
        height: 180px;
      }

      .qrcode-loading,
      .qrcode-error {
        width: 180px;
        height: 180px;
      }
    }

    .qrcode-header .qrcode-title {
      font-size: 16px;
    }

    .qrcode-footer .qrcode-desc {
      font-size: 13px;
    }
  }
}
</style>